import type { UserPreferences } from '@mem-ai-hub/shared';
import { apiClient } from './api';

export async function getPreferences(): Promise<UserPreferences> {
  return apiClient.get<UserPreferences>('/user/preferences');
}

export async function updatePreferences(
  updates: Partial<Omit<UserPreferences, 'id' | 'userId' | 'updatedAt'>>,
): Promise<UserPreferences> {
  return apiClient.put<UserPreferences>('/user/preferences', updates);
}
